export default {
    igloo: {
        iglooHome: 'Igloo Home',
        cardDesc: 'Manage Igloo Home Smart Locks',
        locks: 'Locks',
    },
};
